import React from "react";

import AuthNav from "./auth-nav";

const NavBar = () => {
  return <AuthNav />;
};

export default NavBar;
